import React from 'react';
import { useDrag } from 'react-dnd';

export default function LeftPanelDraggable({ control }) {
  const [{ isDragging }, drag] = useDrag({
    type: control.type === 'Section' ? 'SECTION' : 'CONTROL',
    item: control,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div ref={drag} key={control?.id} data-type={control?.type} data-columns={control?.columns || []} style={{ opacity: isDragging ? 0.5 : 1 }}>
      {control?.label}
    </div>
  );
}
